import React from 'react';

interface LogoProps {
  className?: string;
  isHomepage?: boolean;
}

export default function Logo({ className = "h-20", isHomepage = false }: LogoProps) {
  const handleClick = () => {
    if (isHomepage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div 
      className={`flex items-center ${isHomepage ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <img 
        src="https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/ITLss.svg?alt=media&token=8cd84e38-fe0d-41b9-8f76-71cd3c4037f9" 
        alt="InsighTalks" 
        className={`${className} object-contain scale-80`}
      />
    </div>
  );
}